import { combineReducers } from "redux"
import { chain } from "lodash"
import user from "./user"
import modules from "modules/reducer"
import global from "model/reducer"
import panelsReducer from "../new/connected-components/dashboard/store/panels-slice"
import modelReducer from "../new/connected-components/dashboard/store/model-slice"
import coreReducer from "../new/connected-components/dashboard/store/core-slice"
import tradeReducer from "../new/connected-components/dashboard/store/trade-slice"
import assetViewReducer from "../new/connected-components/dashboard/store/asset-view-slice"
import factorsViewReducer from "../new/connected-components/dashboard/store/factors-view-slice"
import optimizationReducer from "../new/connected-components/dashboard/store/optimization-slice"
import graphReducer from "../new/connected-components/dashboard/store/graph-slice"
import kpiReducer from "../new/connected-components/dashboard/store/kpi-slice"
import instancesReducer from "../new/connected-components/dashboard/store/instances-slice"

const dashboard = combineReducers({
  panels: panelsReducer,
  instances: instancesReducer,
  model: modelReducer,
  core: coreReducer,
  trade: tradeReducer,
  assetView: assetViewReducer,
  factorsView: factorsViewReducer,
  optimization: optimizationReducer,
  graph: graphReducer,
  kpi: kpiReducer,
})

function getReducer(directory, paths) {
  return combineReducers(
    chain(paths.keys())
      .map(path => path.substr(2, path.length - 5))
      .map(path => [path, require(`${directory}/${path}.js`).default])
      .fromPairs()
      .value(),
  )
}

export default combineReducers({
  user,
  app: getReducer("./app", require.context("./app", false, /.js/)),
  modules,
  global,
  dashboard,
})
